<template>
  <a-modal
    title="结算记录详情"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    width="900px"
  >
    <a-descriptions :column="2" bordered>
      <a-descriptions-item label="结算订单ID">
        {{ detailData.settlementNo }}
      </a-descriptions-item>
      <a-descriptions-item label="结算日期">
        <!-- 格式化 -->
        {{ formateDate(detailData.settlementDate) }}
      </a-descriptions-item>
      <a-descriptions-item label="结算金额">
        <span style="color: #1890ff; font-weight: bold;">{{ formatAmount(detailData.settlementAmount, '¥') }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="打款金额">
        <span style="color: #52c41a; font-weight: bold;">{{ formatAmount(detailData.amountPaid, '¥') }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="手续费">
        <span style="color: #fa8c16; font-weight: bold;">{{ formatAmount(detailData.fee, '¥') }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="账户类型">
        <a-tag :color="getAccountTypeColor(detailData.accountType)">
          {{ getAccountTypeText(detailData.accountType) }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="银行名称">
        {{ detailData.bankName }}
      </a-descriptions-item>
      <a-descriptions-item label="银行代码IFSC">
        {{ detailData.ifscCode }}
      </a-descriptions-item>
      <a-descriptions-item label="账户名">
        {{ detailData.accountName }}
      </a-descriptions-item>
      <a-descriptions-item label="账户号">
        {{ detailData.accountName }}
      </a-descriptions-item>
      <a-descriptions-item label="结算状态">
        <a-tag :color="getStatusColor(detailData.status)">
          {{ getStatusText(detailData.status) }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="创建时间" :span="2">
        {{ formateDate(detailData.createdAt) }}
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { formatAmount } from '@/utils/util'

export default {
  name: 'SettlementDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 获取状态文本
    getStatusText (status) {
      const statusMap = {
        100: '等待审核',
        200: '已审核',
        300: '打款中',
        400: '打款成功',
        500: '打款失败',
        600: '审核不通过'
      }
      return statusMap[Number(status)] || '未知'
    },

    // 获取状态颜色
    getStatusColor (status) {
      const colorMap = {
        100: 'orange',
        200: 'green',
        300: 'blue',
        400: 'green',
        500: 'red',
        600: '#ff4d4f'
      }
      return colorMap[status] || 'default'
    },

    // 获取账户类型文本
    getAccountTypeText (type) {
      const typeMap = {
        1: '银行账户',
        2: 'USDT(TRC20)'
      }
      return typeMap[type] || '未知'
    },

    // 获取账户类型颜色
    getAccountTypeColor (type) {
      const colorMap = {
        1: 'blue',
        2: 'purple'
      }
      return colorMap[type] || 'default'
    },

    // 关闭弹窗
    handleCancel () {
      this.$emit('cancel')
    },
    formateDate: function (date) {
      console.log('date》〉》〉', date, typeof date)
      if (!date || date === '' || date === null || date === undefined) {
        return '--'
      }

      // 处理不同类型的时间戳
      let processedDate = date

      // 如果是字符串数字，转换为数字
      if (typeof date === 'string' && !isNaN(date)) {
        processedDate = parseInt(date)
      }

      // 如果是10位时间戳（秒），转换为13位（毫秒）
      if (typeof processedDate === 'number' && processedDate.toString().length === 10) {
        processedDate = processedDate * 1000
      }

      const momentDate = moment(processedDate)
      console.log('processedDate》〉》〉', processedDate, 'momentDate》〉》〉', momentDate, 'isValid:', momentDate.isValid())

      if (!momentDate.isValid()) {
        return '--'
      }

      return momentDate.format('YYYY-MM-DD HH:mm:ss')
    },

    // 引用导入的formatAmount函数
    formatAmount
  }
}
</script>

<style lang="less" scoped>
.ant-descriptions-item-label {
  font-weight: 500;
}

.ant-descriptions-item-content {
  word-break: break-all;
}
</style>
